import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss']
})
export class DialogModalComponent implements OnInit, IBasicModalComponentInstance {
  @Input()
  title;

  @Input()
  body;

  @Input()
  type: BasicModalOperationResult;

  @Input()
  buttons: BasicModalBtn[] = [{
    text: "OK",
    closeModalOnClick: true,
  }];



  basicModalOperationResults = BasicModalOperationResult;

  constructor(public activeModal: NgbActiveModal) {

  }

  ngOnInit() {
  }

  btnClicked(btnClicked: BasicModalBtn) {
    if (btnClicked.handler) {
      btnClicked.handler(btnClicked);
    }
    if (btnClicked.closeModalOnClick)
      this.activeModal.close(btnClicked.text);
  }

  closeModal() {
    this.activeModal.close();
  }
}

export interface IBasicModalComponentInstance {
  title: string;
  body: string;
  type: BasicModalOperationResult;
  buttons: BasicModalBtn[];

  closeModal();
}

export enum BasicModalOperationResult {
  None,
  Error,
  Warning,
  Success,
}

export class BasicModalBtn {
  disabled?: boolean = false;
  closeModalOnClick?: boolean = true;
  text: string;
  handler?: (btn: BasicModalBtn) => void;
  cssClass?;
}

